'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FromLabel = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(FromLabel, _PureComponent);

  function FromLabel() {
    (0, _classCallCheck3.default)(this, FromLabel);
    return (0, _possibleConstructorReturn3.default)(this, (FromLabel.__proto__ || (0, _getPrototypeOf2.default)(FromLabel)).apply(this, arguments));
  }

  (0, _createClass3.default)(FromLabel, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          labelName = _props.labelName;
      var t = this.context.t;


      if (!labelName) {
        return null;
      }

      return _react2.default.createElement(
        'span',
        { className: className },
        t('from {{labelName}}', { labelName: labelName })
      );
    }
  }]);
  return FromLabel;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  labelName: _propTypes2.default.string
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = FromLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/FromLabel/FromLabel.js
// module id = 825
// module chunks = 1